import React, { useEffect, useRef } from 'react';
import { Header } from '../components/Header';
import { FloatingMenu } from '../components/FloatingMenu';
import { Footer } from '../components/Footer';
import { ImageCarousel } from '../components/ImageCarousel';
import { Link } from 'react-router-dom';
export function OriginsOfConsciousness() {
  const headingRef = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    // Scroll to the heading when the component mounts
    if (headingRef.current) {
      headingRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, []);
  const images = [{
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uiR95SvXD3PCXx9RtE5M62/oc-pic1.jpg',
    caption: 'Triton 3300 submarine used during the expedition, capable of diving to depths of 1000 meters'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vnULzJ4J5Bj9SG2tbEck54/oc-pic2.jpg',
    caption: 'Lowering the Triton submarine'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oNeX5UpZ5ZYui5kbBpTAxY/oc-pic3.jpg',
    caption: 'Research team aboard the submarine during the expedition'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/em6rKuMuVENPRNVmUuzxg2/oc-pic4.jpg',
    caption: 'Underwater view from unside the Triton submarine'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tb1bDMXJ1psJ3Rxhuv3XFR/oc-pic5.jpg',
    caption: 'Multibeam sonar scan revealing underwater topography and potential archaeological sites'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uweJoiJmPxVQUUmwiGmDKV/oc-pic6.jpg',
    caption: 'Sonar image showing potential archaeological sites on the seabed'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vi7n7GGXetN7rQCtpumYDm/oc-pic7.jpg',
    caption: 'Research team members aboard the vessel during the expedition'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jX7GcmKKBhcfWrpbrgmiMZ/oc-pic8.jpg',
    caption: 'Research team group with visiting academics on the deck of the expedition vessel'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kY4n7Vh47wceiCpMv8i8gK/oc-pic9.jpg',
    caption: 'Evening meeting of the Improbability Foundation and Tel Aviv University teams'
  }];
  return <div className="flex flex-col min-h-screen w-full" data-id="element-127" data-mp="1rdszazdphoup">
      <FloatingMenu projectPage={true} data-id="element-128" data-mp="1wdfbr6lpn12g" />
      <Header data-id="element-129" data-mp="1wegodfidjvma" />
      <main className="flex-grow w-full bg-gradient-to-b from-[#01052a] to-[#a7c0d2]" data-id="element-130" data-mp="1wf8guhgodd8c">
        <div className="container mx-auto px-4 py-12 text-white" data-id="element-131" data-mp="1if7gr488i9tx">
          <div className="max-w-4xl mx-auto" data-id="element-132" data-mp="1nch66jvmilhr">
            {/* Hero section */}
            <h1 ref={headingRef} className="text-4xl font-bold text-center mb-4" id="project-title" data-id="element-133" data-mp="3crxc7qe93r3f">
              Origins of Consciousness
            </h1>
            <h2 className="text-xl text-center mb-8 text-blue-200 italic" data-id="element-134" data-mp="3rufb54p5p7ip">
              Concluding the first phase of the 'Origins of Consciousness'
              underwater archeological expedition in search of evidence of
              psychedelics in ancient shipwrecks
            </h2>
            {/* Lead image */}
            <div className="mb-10 rounded-lg overflow-hidden shadow-xl" data-id="element-135" data-mp="3vvhcbr2mvtnb">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7qEjTuxqtvdFLoooxNNavF/underwater-sub-for-web.jpg" alt="Origins of Consciousness expedition submarine" className="w-full h-auto" data-id="element-136" data-mp="efsib0r9yb32" />
            </div>
            {/* Main content - first 6 paragraphs */}
            <div className="prose prose-lg prose-invert max-w-none" data-id="element-137" data-mp="jgges1y9vk4o">
              <p className="text-lg mb-4" data-id="element-138" data-mp="2p7k6kjmnbnzz">
                Improbability Foundation is delighted to have supported the
                'Origins of Consciousness' underwater expedition in cooperation
                with the Institute of Archeology of Tel Aviv University and
                Underwater Archeology Unit of the Israeli Antiquities Authority
                in the Ashdod-Yam (Ashdod-by-the-Sea) area off the southern
                coast of Israel.
              </p>
              <p className="text-lg mb-4" data-id="element-139" data-mp="30ngjpvyimmxm">
                'Origins of Consciousness' took place between the 15th and 30th
                of August, 2022. The goal of the expedition was to search for
                and explore the ancient shipwrecks in the Ashdod-Yam coastal
                areas in depths from 5 to 1000 metres using а U-Boat Navigator
                research vessel, equipped with a Triton 3300 submarine,
                Multibeam sonar, and other modern underwater search and
                exploration equipment.
              </p>
              <p className="text-lg mb-4" data-id="element-140" data-mp="1k8nihzjhczzm">
                One of the major research objectives of the project was to
                discover more about how and why entheogenic substances have been
                used in ancient cultures in order to understand how they may
                have influenced the evolution of both collective and individual
                consciousness.
              </p>
              <p className="text-lg mb-4" data-id="element-141" data-mp="17orpr0sweu3g">
                Both from the team's existing academic and practical experience,
                and also from scientific and historical literature, it is known
                that 'organic' substances can survive very well for thousands of
                years in an underwater environment, especially if they are
                covered in certain types of sediment, or if they are located in
                an anaerobic environment at depths of several hundred metres or
                more.
              </p>
              <p className="text-lg mb-4" data-id="element-142" data-mp="fzolhl10hjqt">
                Over the past decade, some exceptionally strong winter storms
                have removed sand layers, occasionally exposing the remains of
                sunken ships and cargoes. Increasing evidence of the presence of
                ancient shipwrecks and cargoes have been reported by fishermen
                and recreational divers in this area, with sightings of amphorae
                and other pottery, different types of anchors and other maritime
                artefacts. The same holds true for many coastal facilities
                located on the narrow coastal strip of land.
              </p>
              <p className="text-lg mb-4" data-id="element-143" data-mp="p2109n29xbxm">
                Historical sources and archaeological evidence suggest that
                Ashdod-Yam's original 'raison d'être' was affiliated with the
                sea, as it was an integral part of an extensive Mediterranean
                coastal network. Unlike many other Israeli coastal sites, no
                systematic underwater research has been carried out to date in
                the sea off Ashdod-Yam, and so the expedition sought to identify
                a number of shipwrecks in the area near the ancient port.
              </p>
            </div>
            {/* Image carousel - moved between 6th and 7th paragraphs */}
            <div className="my-12" data-id="element-144" data-mp="31bhjjw3hozol">
              <h3 className="text-2xl font-bold text-center mb-6" data-id="element-145" data-mp="31afz510l30u7">
                Expedition Gallery
              </h3>
              <ImageCarousel images={images} data-id="element-146" data-mp="2xafhz8m3objg" />
            </div>
            {/* Main content - remaining paragraphs */}
            <div className="prose prose-lg prose-invert max-w-none mt-12" data-id="element-147" data-mp="29mfm5u9xluy0">
              <p className="text-lg mb-4" data-id="element-148" data-mp="24mt6zfajm4mk">
                Our underwater expedition specifically focused on locating
                ritual and other culturally significant items that might contain
                traces of psychoactive alkaloids with a view to holistically
                exploring and connecting a variety of archaeological remains
                from the both shallow and deep submerged landscapes to similar
                archaeological remains located on the land and near the shore.
              </p>
              <p className="text-lg mb-4" data-id="element-149" data-mp="cvz85old9yn3">
                In addition to conducting typical archaeological work of dating
                and identifying the origins of the specific wrecks and items, a
                targeted residue analysis of the ceramic samples found in the
                wrecks was performed in order to identify the organic substances
                that have been present in those vessels, cups or amphoras at the
                time of the wrecks.
              </p>
              <p className="text-lg mb-8" data-id="element-150" data-mp="10p7o5gm6c0fu">
                Through investigating ancient ritual items that might contain
                traces of entheogens, we intend to discover more evidence about
                how these substances could have been used for various ceremonial
                and healing purposes, and learn more about how they might have
                influenced the development of not only their societies, but also
                their myths and religions.
              </p>
              <div className="text-center mt-12" data-id="element-151" data-mp="33xre6weei6fk">
                <Link to="/" className="inline-block bg-white/10 backdrop-blur-sm text-white px-6 py-3 rounded-full hover:bg-white/20 transition-colors" data-id="element-152" data-mp="2z4etgxcuejs3">
                  Return to Main Page
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-153" data-mp="3msetyozyhojv" />
    </div>;
}